export default "__VITE_ASSET__4c576859__"